import { Modal } from "../../components/ui/modal.tsx";
import styles from "./issaInsights.module.scss";

/**
 * Full-size viewer for a generated image in the Issa chat. Opened by clicking
 * an image inside an answer; closes on Escape, the backdrop, or the button.
 */
export function ImageLightbox({ src, onClose }: { src: string; onClose: () => void }) {
  return (
    <Modal open onClose={onClose} maxWidth="min(96vw, 1600px)">
      <div className={styles.lightboxBody}>
        <img src={src} alt="Generated image, full size" className={styles.lightboxImage} />
        <button
          type="button"
          className={styles.lightboxClose}
          onClick={onClose}
          aria-label="Close image"
        >
          <svg
            viewBox="0 0 24 24"
            width="16"
            height="16"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            aria-hidden="true"
          >
            <path d="M6 6 L18 18 M18 6 L6 18" />
          </svg>
        </button>
      </div>
    </Modal>
  );
}
